import React from 'react';
import ChamadoStatusCard from './ChamadoStatusCard';
import ChamadoResponsavelCard from './ChamadoResponsavelCard';
import ChamadoSprintCard from './ChamadoSprintCard';
import ChamadoTimeCard from './ChamadoTimeCard';
import ChamadoCollaboratorsCard from './ChamadoCollaboratorsCard';
import ChamadoActionsCard from './ChamadoActionsCard';
import ChamadoRetomarCard from './ChamadoRetomarCard';
import SlaIndicator from '../Components/Sla/SlaIndicator';
import AssistenteIA from '../Components/AssistenteIA/AssistenteIA';
import WatchersCard from '../Components/WatchersCard/WatchersCard';
import AvaliacaoCard from '../Components/AvaliacaoCard/AvaliacaoCard';

function ChamadoSidebar(props) {
    const encerrado = props.chamadoEncerrado === true;

    return (
        <aside className="chamado-sidebar">
            {props.satNum > 0 && <SlaIndicator satNum={props.satNum} compact />}
            {props.satNum > 0 && !encerrado && <AssistenteIA satNum={props.satNum} />}
            {props.satNum > 0 && <WatchersCard satNum={props.satNum} />}
            {props.satNum > 0 && encerrado && <AvaliacaoCard satNum={props.satNum} />}
            <ChamadoStatusCard
                statusAtual={props.statusAtual}
                statusParaSelect={props.statusParaSelect}
                getNomeStatus={props.getNomeStatus}
                onChange={props.onStatusChange}
                readOnly={encerrado}
            />
            <ChamadoResponsavelCard
                atendenteNome={props.atendenteNome}
                opcoesAtendentes={props.opcoesColaboradores}
                novoResponsavelId={props.novoResponsavelId}
                onNovoResponsavelChange={props.onNovoResponsavelChange}
                onAtribuir={props.onAtribuirAtendente}
                salvandoAtribuicao={props.salvandoAtribuicaoAtendente}
                carregandoOpcoes={props.carregandoOpcoesColaboradores}
                readOnly={encerrado}
            />
            <ChamadoSprintCard sprintId={props.sprintId} sprintNome={props.sprintNome} />
            <ChamadoTimeCard
                estimativaHoras={props.estimativaHoras}
                tempoTrabalhadoTexto={props.tempoTrabalhadoTexto}
                tempoAnaliseTexto={props.tempoAnaliseTexto}
                tempoTesteTexto={props.tempoTesteTexto}
                emPeriodoAberto={encerrado ? false : props.emPeriodoAberto}
                emPeriodoAbertoAnalise={encerrado ? false : props.emPeriodoAbertoAnalise}
                emPeriodoAbertoTeste={encerrado ? false : props.emPeriodoAbertoTeste}
                tempoTrabalhadoMinutos={props.tempoTrabalhadoMinutos}
                usaSprint={props.usaSprint}
            />
            <ChamadoCollaboratorsCard
                colaboradores={props.colaboradores}
                carregandoColaboradores={props.carregandoColaboradores}
                opcoesColaboradores={props.opcoesColaboradores}
                novoColaboradorId={props.novoColaboradorId}
                onNovoColaboradorChange={props.onNovoColaboradorChange}
                onAdicionar={props.onAdicionarColaborador}
                onRemover={props.onRemoverColaborador}
                salvandoColaborador={props.salvandoColaborador}
                carregandoOpcoesColaboradores={props.carregandoOpcoesColaboradores}
                readOnly={encerrado}
            />
            {encerrado ? (
                <ChamadoRetomarCard onRetomar={props.onRetomarAtendimento} loading={props.retomarLoading} />
            ) : (
                <ChamadoActionsCard
                    onIniciar={props.onIniciarAtendimento}
                    onPausar={props.onPausar}
                    onConcluir={props.onConcluir}
                />
            )}
            {props.anexosCard != null && (
                <div className="chamado-sidebar-card chamado-sidebar-anexos-wrap" ref={props.anexosCardRef}>
                    {props.anexosCard}
                </div>
            )}
        </aside>
    );
}

export default ChamadoSidebar;
